import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import styles from "../../../../src/content/hispanic-initiative-ministry-update/styles";
import "../../../../src/content/hispanic-initiative-ministry-update/hispanic-initiative-update.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  styles,
  React
};